import { render, staticRenderFns } from "./ViAdmissionSchoolOverview.vue?vue&type=template&id=3646d3b7"
import script from "./ViAdmissionSchoolOverview.vue?vue&type=script&lang=js"
export * from "./ViAdmissionSchoolOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports